module.exports = __webpack_public_path__ + "img/web-camera.231e25e1.png";